import { VoohMediaCheckboxTreeElement, VoohMediaNode } from '../VoohCampaignForm/types'
import offerService from '../../Campaign/CampaignForm/DetailsForm/services/offer-form.service'
import { MediumPlaceDetails, VOOH_OFFER } from '../../../types/campaign'
import { Role } from '../../../types/user'
import { TFunction } from 'i18next'

export default class VoohMediaSelectionService {
  static getUuid = (index: number) => {
    return (Date.now() + Math.random() + index).toString()
  }

  static buildMediaTreeCheckboxNodes: any = (
    mediaTree: VoohMediaNode[],
    offer: VOOH_OFFER,
    roles: Role[],
    flattenNodeValues: string[],
    mediaSize: number,
    t: TFunction
  ) => {
    return [...mediaTree]
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map((element: VoohMediaNode, index) => {
        if (element.children && element.children.length > 0) {
          let mediaType = ''
          if (element.type === 'Media::Agglomeration') {
            mediaType = `(${t('form.campaign.details.voohMediaNodes.agglomeration')})`
          } else if (element.type === 'Media::City') {
            mediaType = `(${t('form.campaign.details.voohMediaNodes.city')})`
          }
          const val =
            (element.id || element.name) +
            '_' +
            element.type +
            VoohMediaSelectionService.getUuid(index)
          return {
            value: val,
            disabled: offerService.disableEditVoohMedium(roles, offer, mediaType),
            label: element.name + ' ' + `${mediaType}`,
            children: VoohMediaSelectionService.buildMediaTreeCheckboxNodes(
              element.children,
              offer,
              roles,
              flattenNodeValues,
              mediaSize,
              t
            ),
          }
        } else {
          const val = element.id + '_' + element.type + VoohMediaSelectionService.getUuid(index)
          flattenNodeValues.push(val)
          mediaSize += 1
          return {
            value: val,
            label: element.asId ? element.asId + ' - ' + element.brand?.name : element.name,
          }
        }
      })
  }

  static filterNodes = (filterNodesText: string) => {
    return (filtered: VoohMediaCheckboxTreeElement[], node: VoohMediaCheckboxTreeElement) => {
      if (
        // Node's label matches the search string
        node.label.toLocaleLowerCase().match(filterNodesText.toString().toLocaleLowerCase())
      ) {
        filtered.push(node)
        return filtered
      }

      if (node.children && node.children.length > 0) {
        const children = (node.children || []).reduce(
          VoohMediaSelectionService.filterNodes(filterNodesText),
          []
        )
        if (children.length > 0) {
          filtered.push({ ...node, children })
        }
      }
      return filtered
    }
  }

  static filterNodesByIds = (filterByIds: string, checkedMediaOnFilterById: string[]) => {
    return (filtered: VoohMediaCheckboxTreeElement[], node: VoohMediaCheckboxTreeElement) => {
      const filterByIdsArr = (filterByIds || '').split(/,| |;/)
      const nodeId = node.label.split('-')[0].trim()
      if (
        // Node's label matches the search string
        filterByIdsArr.some(filteredNodeId => filteredNodeId === nodeId)
      ) {
        if (node.value.includes('_Medium')) {
          checkedMediaOnFilterById.push(node.value)
        }

        filtered.push(node)
        return filtered
      }

      if (node.children && node.children.length > 0) {
        const children = (node.children || []).reduce(
          VoohMediaSelectionService.filterNodesByIds(filterByIds, checkedMediaOnFilterById),
          []
        )
        if (children.length > 0) {
          filtered.push({ ...node, children })
        }
      }
      return filtered
    }
  }

  static getSelectedMediaArrayFromTree = (entireObj: VoohMediaNode[], checkedNodes: string[]) => {
    const foundArr: VoohMediaNode[] = []
    let building: MediumPlaceDetails
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (nestedValue?.type === 'Media::Building') {
        building = nestedValue
      }
      if (nestedValue && checkedNodes.some(el => el.split('_')[0] === nestedValue.id?.toString())) {
        foundArr.push({ ...nestedValue, building })
      }
      return nestedValue
    })
    return foundArr
  }
}
